import { Flex, type StackProps } from "@chakra-ui/react";
import { type FC } from "react";
import { Input } from "@/components/essentials/input";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel } from "@/components/essentials/form-control";
import {
  promotionCodeField,
  promotionCodeFormButtonTestId,
  promotionCodeFormInputTestId,
  promotionCodeFormLabelTestId,
} from "./const";
import get from "just-safe-get";
import { Button } from "@/components/essentials/button";
import { type PromotionCodeFormValue } from "./type";

export interface PromotionCodeFormProps extends StackProps {
  readonly promotionCodeLoading: boolean;
}

export const PromotionCodeForm: FC<PromotionCodeFormProps> = ({ promotionCodeLoading, ...rest }) => {
  const {
    register,
    formState: { errors, dirtyFields, isValid },
  } = useFormContext<PromotionCodeFormValue>();

  return (
    <FormControl
      isDirty={get(dirtyFields, promotionCodeField)}
      isInvalid={get(errors, promotionCodeField) !== undefined}
      id={promotionCodeField}
    >
      <FormLabel data-testid={`${promotionCodeFormLabelTestId}-${promotionCodeField}`}>
        プロモーションコード（お持ちの方のみ）
      </FormLabel>
      <Input
        data-testid={`${promotionCodeFormInputTestId}-${promotionCodeField}`}
        placeholder="例：TOYSUB20"
        type="text"
        mb="4"
        {...register("promotionCode", { required: true })}
        {...rest}
      />
      <Flex justifyContent="flex-end">
        <Button
          type="submit"
          size="lg"
          styleVariant="secondary"
          disabled={!isValid || promotionCodeLoading}
          isLoading={promotionCodeLoading}
          data-testid={`${promotionCodeFormButtonTestId}-${promotionCodeField}`}
        >
          コードを適用する
        </Button>
      </Flex>
    </FormControl>
  );
};
